import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'trial-button',
    templateUrl: './trial-button.component.html',
    styleUrls: ['./trial-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrialButtonComponent {

  @Input() daysRemaining: number = 0;
  @Input() expired: boolean = false;
  @Output() upgradeClick = new EventEmitter<void>();

  onUpgradeClick(): void {
    this.upgradeClick.emit();
  }

  public get jsonClasses() {
    return {
      'btn-danger': this.expired || this.daysRemaining === 0,
      'btn-warning': this.daysRemaining === 1,
      'btn-dark': this.daysRemaining > 1,
    };
  }

}
